import type { IBlock } from '@/types/block';
import type { IBlockCacheDebugInfo } from './types';

import { WeekDays } from '@/store/enums';
import { Block } from '@/classes/Block';
import { BlockCache } from './BlockCache';

export class CachedBlock extends Block implements IBlock {
  private constructor(blockId: number, timezoneName: string) {
    super(blockId, timezoneName);
  }

  static fromBlockId(blockId: number, timezoneName: string): IBlock {
    const cache = BlockCache.getInstance(timezoneName);
    return cache.getBlock(blockId);
  }

  static fromMillis(utcMillis: number, timezoneName: string): IBlock {
    const cache = BlockCache.getInstance(timezoneName);
    const blockId = Block.getBlockIdByMillis(utcMillis);
    return cache.getBlock(blockId);
  }

  /**
   * @param day - determines which day of the week the Block is created for
   * @param startOrEnd - determines if the Block object is created from first or last block of given day
   */
  static fromWeekId(
    weekId: number,
    timezoneName: string,
    day: WeekDays = WeekDays.Monday,
    startOrEnd: 'start' | 'end' = 'start',
  ): IBlock {
    const cache = BlockCache.getInstance(timezoneName);
    const blockId = Block.getBlockIdByWeekId(weekId, timezoneName, day, startOrEnd);
    return cache.getBlock(blockId);
  }

  static debug(): IBlockCacheDebugInfo {
    return BlockCache.debug();
  }
}
